module.exports = __webpack_public_path__ + "resources/35fae7827b542b4908615f33f30e07d6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundsupermove4.png
// module id = 198
// module chunks = 0